module.exports = __webpack_public_path__ + "img/Icon material-call.1917edea.svg";